import { Modal, Textarea } from "@mantine/core";
import PropTypes from "prop-types";
import { useForm } from "@mantine/form";
import { showNotification, updateNotification } from "@mantine/notifications";

import {
  TextInput,
  Button,
  Box,
  Group,
  NumberInput,
  Text,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { addTaskApi } from "../../api/tasks";
import { getAdminTasks } from "../../api/tasks";

async function getAdminTasksF() {
  const res = await getAdminTasks().catch((err) => {
    showNotification({
      title: "ERROR",
      message:
        err.response != null
          ? err.response.data != null
            ? err.response.data.message != null
              ? err.response.data.message
              : err.message
            : err.message
          : err.message,
      color: "red",
    });
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
    return;
  });
  if (res.status == 200) {
    return res.data;
  } else {
    showNotification({
      title: "ERROR",
      message: res.data.message,
      color: "red",
    });
    return [];
  }
}

function AddTaskModal({ open, setOpen }) {
  const [domains, setDomains] = useState([]);
  useEffect(() => {
    getAdminTasksF().then((res) => {
      //console.log(res);
      // setLoad(false);
      const domains = res.domains.map((domain) => {
        return {
          value: domain.name,
          label: domain.name,
        };
      });
      setDomains(domains);
    });
  }, []);

  const handleForm = async (values) => {
    //console.log(values);
    showNotification({
      id: "AddTask",
      title: "Adding Task",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    const formData = new FormData();
    formData.append("title", values.name);
    formData.append("taskNo", values.taskNo);
    formData.append("deadline", values.deadline);
    formData.append("domain", values.domain);
    formData.append("content", values.content);
    formData.append("subAllowed", values.subAllowed);
    formData.append("showResult", values.showResult);
    formData.append("evalNotes", values.evalNotes);
    const file = document.querySelector("#fileInput");
    if (file && file.files[0]) {
      //console.log(file.files[0]);
      formData.append("task", file.files[0]);
    }

    const res = await addTaskApi(formData).catch((err) => {
      updateNotification({
        id: "AddTask",
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
          localStorage.clear();
          window.location.replace("/");}
      }
      return;
    });
    if (res != null) {
      if (res.status == 200) {
        updateNotification({
          id: "AddTask",
          title: "Success",
          message: res.data.message,
          color: "green",
        });
        location.reload();
        setOpen(false);
      } else {
        updateNotification({
          id: "AddTask",
          title: "ERROR",
          message: res.data.message,
          color: "red",
        });
        return;
      }
    }
  };

  const initialValue =
    "<p>Your initial <b>html value</b> or an empty string to init editor without value</p><br><br><br><br>";
  const [value, onChange] = useState(initialValue);

  const form = useForm({
    initialValues: {
      name: "",
      deadline: new Date(),
      domain: "",
      content: "",
      evalNotes: "",
      taskNo: "",
      subAllowed: true,
      showResult: false,
      task: "",
    },
  });

  return (
    <Modal
      opened={open}
      onClose={() => setOpen(false)}
      title="Add Task"
      size="100%"
      overflow="inside"
    >
      <Box mx="auto">
        <form
          onSubmit={form.onSubmit((values) => {
            const file = document.querySelector("#fileInput");
            if (!file || !file.files[0]) {
              showNotification({
                title: "ERROR",
                message: "Please submit PDF",
                color: "red",
              });
            } else {
              handleForm(values);
            }
          })}
        >
          <Select
            label=" Select Domain"
            placeholder="Pick one"
            data={domains}
            // data={[
            //   { value: "Web Dev", label: "Web Dev" },
            //   { value: "DevOps", label: "DevOps" },
            //   { value: "ML", label: "ML" },
            //   { value: "Algos", label: "Algos" },
            //   { value: "Tronix", label: "Tronix" },
            // ]}
            required
            {...form.getInputProps("domain")}
          />

          <NumberInput
            placeholder="Enter Task No."
            label="Task No."
            mt="sm"
            required
            {...form.getInputProps("taskNo")}
          />
          <TextInput
            required
            label="Task Name:"
            placeholder="Enter Task Name"
            mt="sm"
            {...form.getInputProps("name")}
          />

          <Textarea
            label="Content:"
            placeholder="Write Content For Task"
            value={value}
            mt="sm"
            minRows={5}
            onChange={onChange}
            required
            {...form.getInputProps("content")}
          />

          <Textarea
            required
            label="Evaluation Notes::"
            placeholder="Enter Eval Notes"
            mt="sm"
            minRows={4}
            {...form.getInputProps("evalNotes")}
          />

          <DatePicker
            placeholder="Pick date"
            label="Deadline:"
            required
            mt="sm"
            {...form.getInputProps("deadline")}
          />

          <Text style={{ marginTop: "10px", fontWeight: "500" }}>
            Add Task File:<span style={{ color: "red" }}>*</span>
          </Text>
          <input
            type="file"
            id="fileInput"
            name="task"
            {...form.getInputProps("task")}
            accept="image/zip"
          />
          <Group position="right" mt="xl">
            <Button type="submit">Submit</Button>
          </Group>
        </form>
      </Box>
    </Modal>
  );
}

AddTaskModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.bool,
};

export default AddTaskModal;
